module.exports = __webpack_public_path__ + "static/media/Notion_ai_ex1a.5a493fce.png";